import usePageTracking from './hooks/useGAPageTracking';

const PageTracker = () => {
  usePageTracking();
  return null;
};

export default PageTracker;
